<template>
  <div class="download" v-if="contentVisible">
    <div class="mask" v-show="mask">
      <div class="info" v-if="lang === 'cn'">
        <div class="line">
          <img src="./imgs/one.png" alt="">
          <span class="ml10">点击</span>
          <img src="./imgs/select.png" alt="">
          <span>右上角的按钮</span>
        </div>
        <div class="line" style="margin-top: 0.1rem">
          <img src="./imgs/two.png" alt="">
          <span class="ml10">选择</span>
          <img src="./imgs/Browser.png" alt="">
          <span>在浏览器打开</span>
        </div>
      </div>
      <div class="info" v-else>
        <div class="line">
          <img src="./imgs/one.png" alt="">
          <span class="ml10">Tap</span>
          <img src="./imgs/select.png" alt="">
          <span>icon in the top right corner</span>
        </div>
        <div class="line" style="margin-top: 0.1rem">
          <img src="./imgs/two.png" alt="">
          <span class="ml10">Click</span>
          <img src="./imgs/Browser.png" alt="">
          <span>Open in browser</span>
        </div>
      </div>
      <div class="arrow">
        <img src="./imgs/arrow.png" alt="">
      </div>
    </div>
    <div class="container flex jc-c ai-c">
      <div class="content">
        <div class="info">
          <img class="logo" :src="logo" alt="">
        </div>
        <div class="button flex jc-c ai-c" @click="jump">
          <span class="btn-txt">{{btnTxt}}</span>
          <img class="btn-icon" src="./imgs/download.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 1 android, 2 ios
      device: 1,
      mask: false,
      logo: '',
      lang: 'en',
      query: '',
      contentVisible: false
    }
  },
  created () {
    this.lang = this.checkLanguage()
    if (this.lang === 'cn') {
      this.logo = require('./imgs/logo3.png')
    } else {
      this.logo = require('./imgs/logo2.png')
    }
    let query = {}
    let queryArray = window.location.search.substr(1).split('&')
    if (queryArray && queryArray.length) {
      queryArray.forEach(i => {
        let params = i.split('=')
        query[params[0]] = params[1]
      })
    }
    this.query = query.r
    if (document.body.offsetWidth > 1024) {
      this.buriedPoint(4)
      let url = ''
      let origin = ''
      if (window.isCdn) {
        origin = 'https://scanner.hithink.com'
      } else {
        origin = 'https://scanner.myhithink.com'
      }
      window.location.href = this.query ? origin + '?r=' + this.query + '#/download' : origin + '/#/download'
      return
    } else {
      this.contentVisible = true
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.title = this.lang === 'cn' ? '口袋扫描仪-专业扫描&识别文档' : 'Scanner HD | Scan your documents anywhere anytime'
      let head = document.getElementsByTagName('head')
      let meta = document.createElement('meta')
      let meta2 = document.createElement('meta')
      meta.name = 'description'
      meta.content = this.lang === 'cn' ? '一键将文档、纸、名片等转成PDF、png，现在下载免费送OCR~' : 'Finish your works easily with an automatic process including detect, scan and extracted recognition (OCR)  technology.'
      // meta.content = this.lang === 'cn' ? '一键将文档、纸、名片等转成PDF、png，现在下载免费送OCR~' : 'Finish your works easily with an automatic process including detect, scan and extracted recognition (OCR)  technology.'
      meta2.setAttribute('property', 'og:description')
      meta2.content = this.lang === 'cn' ? '一键将文档、纸、名片等转成PDF、png，现在下载免费送OCR~' : 'Finish your works easily with an automatic process including detect, scan and extracted recognition (OCR)  technology.'
      head[0].appendChild(meta2)
      head[0].appendChild(meta)
    })
    this.checkDevice()
    // setTimeout(() => {
    //   this.jump()
    // }, 1000)
  },
  computed: {
    btnTxt () {
      if (this.lang === 'cn') {
        return '立刻下载'
      } else {
        return 'Get it Now'
      }
    }
  },
  methods: {
    checkDevice () {
      let userAgent = navigator.userAgent
      if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
        this.device = 1
      } else if (!!userAgent.match(/(?:iPhone)/) || !!userAgent.match(/(?:iPad)/) || !!userAgent.match(/(?:Mac)/)) {
        this.device = 2
      } else {
        this.device = 1
      }
    },
    checkWeChat () {
      let userAgent = navigator.userAgent
      if (/MicroMessenger/i.test(userAgent)) {
        return true
      }
      return false
    },
    checkPhoneBrand () {
      var ua = navigator.userAgent.split("(")[1].split(")")[0];
      var brand = "";
      var phone = [/IPHONE/gi, /huawei|honor|hdh60-l01|dub/gi, /mi|MI|Redmi|HM|kot49h|mmb/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
      if (phone[0].test(ua)) {
          brand = "iPhone";
      } else if (phone[1].test(ua)) {
          brand = "huawei";
      } else if (phone[2].test(ua)) {
          brand = "xiaomi";
      } else if (phone[3].test(ua)) {
          brand = "vivo";
      } else if (phone[4].test(ua)) {
          brand = "OPPO";
      } else if (phone[5].test(ua)) {
          brand = "SAMSUNG";
      } else if (phone[6].test(ua)) {
          brand = "SONY";
      } else if (phone[7].test(ua)) {
          brand = "Nokia";
      } else if (phone[8].test(ua)) {
          brand = "HTC";
      } else if (phone[9].test(ua)) {
          brand = "ZTE";
      } else if (phone[10].test(ua) || phone[11].test(ua)) {
          brand = "Lenovo";
      } else {
          brand = "Android";
      }
      console.log(brand, 'phone brand')
      return brand
    },
    checkLanguage () {
      let lang = localStorage.getItem('localeLanguage') || (navigator.language || navigator.browserLanguage).toLowerCase()
      if (lang.indexOf('cn') > -1) {
        return 'cn'
      } else {
        return 'en'
      }
    },
    // autoJump () {
    //   let href = ''
    //   let isWeChat = this.checkWeChat()
    //   if (isWeChat) {
    //     location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hithink.scannerhd'
    //     return
    //   }
    //   if (this.device === 1) {
    //     if (this.lang === 'cn') {
    //       this.buriedPoint(1)
    //       location.href = this.downloadWithQuery()
    //     } else {
    //       this.buriedPoint(2)
    //       location.href = 'https://play.google.com/store/apps/details?id=com.hithink.scannerhd'
    //     }
    //   } else {  // ios
    //     this.iosDownload()
    //     this.buriedPoint(3)
    //   }
    // },
    // clickJump () {
    //   if (this.device === 1) {
    //     if (this.lang === 'cn') {
    //       this.buriedPoint(1)
    //       // location.href = "https://d7evxxtys43ia.cloudfront.net/install/android/scannerHD.apk?t=" + Date.parse(new Date())
    //       location.href = this.downloadWithQuery()
    //     } else {
    //       this.buriedPoint(2)
    //       location.href = 'https://play.google.com/store/apps/details?id=com.hithink.scannerhd'
    //     }
    //   } else {
    //     this.iosDownload()
    //     this.buriedPoint(3)
    //   }
    // },
    jump () {
      let href = ''
      let isWeChat = this.checkWeChat()
      if (isWeChat) {
        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hithink.scannerhd'
        return
      }
      if (this.device === 1) {
        if (this.lang === 'cn') {
          this.buriedPoint(1)
          this.downloadWithQuery()
        } else {
          this.buriedPoint(2)
          // location.href = 'https://play.google.com/store/apps/details?id=com.hithink.scannerhd'
          location.href = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.hithink.scannerhd&ddl=1&pcampaignid=web_ddl_1'
        }
      } else {  // ios
        this.iosDownload()
        this.buriedPoint(3)
      }
    },
    buriedPoint (type) {
      window.gtag('event', 'aH5Down', {'to': type})
    },
    downloadWithQuery () {
      let url = ''
      let query = this.query
      let brand = this.checkPhoneBrand()
      if (brand === 'huawei') {
        url = 'appmarket://details?id=com.hithink.scannerhd'
        setTimeout(() => {
          location.href = 'https://appstore.huawei.com/app/C100895715'
        }, 3000)
      } else if (brand === 'xaiomi') {
        url = 'mimarket://details?id=com.hithink.scannerhd'
        setTimeout(() => {
          location.href = 'http://app.mi.com/details?id=com.hithink.scannerhd&ref=search	'
        }, 3000)
      } else if (query) {
        url = window.isCdn ? 'https://d7evxxtys43ia.cloudfront.net/install/android/' + query + '/scannerHD.apk?t=' + Date.parse(new Date()) : 'https://myhithink.com/install/android/' + query + '/scannerHD.apk?t=' + Date.parse(new Date())
      } else {
        url = window.isCdn ? 'https://d7evxxtys43ia.cloudfront.net/install/android/scannerHD.apk?t=' + Date.parse(new Date()) : 'https://myhithink.com/install/android/scannerHD.apk?t=' + Date.parse(new Date())
      }
      console.log('apk url', brand, url)
      location.href = url
    },
    iosDownload () {
      let query = this.query
      if (query) {
        location.href = 'https://itunes.apple.com/app/apple-store/id1457649898?pt=464212&ct=' + query + '&mt=8'
      } else {
        location.href = this.lang === 'cn' ? 'https://itunes.apple.com/cn/app/scanner-hd/id1457649898?mt=8' : 'https://itunes.apple.com/app/scanner-hd/id1457649898?mt=8'
      }
    }
  }
}
</script>

<style>
.download {
  height: 100%;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: url('./imgs/backgroung2.jpg') no-repeat center;
  background-size: cover;
  position: relative;
}
.container {
  height: 3.7rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: url('./imgs/backgroung1.png') no-repeat center;
  background-size: cover;
}
.container .content {
  margin-top: 0.4rem
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 100;
  display: flex;
  justify-content: flex-end;
}
.mask .arrow {
  margin-right: 0.18rem;
  width:  0.8rem;
}
.arrow img {
  display: block;
  max-width: 0.8rem;
}
.mask .info {
  margin-right: 0.14rem;
  margin-top: 0.5rem;
}
.info .line {
  display: flex;
  height: 0.36rem;
}
.info .line img {
  display: block;
  width: 0.36rem;
  height: 0.36rem;
  margin: 0 0.06rem
}
.info span {
  font-size: 0.36rem;
  color: #fff;
  line-height: 0.36rem;
  display: block
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}
.logo {
  width: 3.6rem;
  height: 1rem;
  display: block
}
.button {
  background: #C82133;
  border-radius: 40px;
  width: 3.2rem;
  height: 0.8rem;
  margin-top: 0.4rem
}
.button .btn-txt {
  font-size: 0.3rem;
  color: #FFFFFF;
  font-weight: bold
}
.button .btn-icon {
  width: 0.32rem;
  height: 0.32rem;
  margin-left: 0.2rem
}
.button .btn-icon img {
  width: 0.32rem;
  height: 0.32rem;
}
.flex {
  display: flex;
}
.jc-c {
  justify-content: center
}
.ai-c {
  align-items: center
}
.ml10 {
  margin-left: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/scanner-download/index.vue